import { AddRounded, DeleteRounded } from "@mui/icons-material";
import { Box, Grid, IconButton, Tooltip } from "@mui/material";
import { FunctionComponent, SyntheticEvent } from "react";
import { useHasScope } from "../../../config/globalConfig";
import CBAccordionTitle from "./CBAccordionTitle";
import { CBAuth } from "../types";

interface UpdateBtnsAccordionProps {
    section?: 'cbDetails' | 'cbPersonalOrganizationInfo' | 'cbInvoicingAddress' | 'salesAreas' | 'cbPaymentInfo' | 'cbCorporateInfo',
    label: string,
    editing: boolean,
    isExpanded?: boolean,
    disabledSave?: boolean,
    disableAdd?: boolean,
    showAdd?: boolean,
    customIcon?: React.ReactElement<any, any>,
    showCustomIcon?: boolean,
    tooltipTitleCustomIcon?: string,
    tooltipTitleAddIcon?: string,
    showRemove?: boolean,
    onSetEditing?: (event: SyntheticEvent) => void,
    onResetForm?: (event: SyntheticEvent) => void,
    onSave?: (event: SyntheticEvent) => void,
    onAdd?: (event: SyntheticEvent) => void,
    onClickCustomIcon?: (event: SyntheticEvent) => void,
    onRemove?: (event: SyntheticEvent) => void

}

const UpdateBtnsAccordion: FunctionComponent<UpdateBtnsAccordionProps> = ({
    section,
    label,
    editing,
    isExpanded,
    disabledSave,
    disableAdd = false,
    showAdd = false,
    customIcon,
    showCustomIcon = false,
    tooltipTitleCustomIcon,
    tooltipTitleAddIcon,
    showRemove = false,
    onSetEditing,
    onResetForm,
    onSave,
    onAdd,
    onClickCustomIcon,
    onRemove
    
}) => {

    //const anotherSectionIsInEdit = useRecoilValue(anotherSectionIsInEditState);
    //const setAnotherSectionIsInEdit = useSetRecoilState(anotherSectionIsInEditState);
    const hasScope = useHasScope;
    
    return (
        <Grid container alignItems="center" width={"98%"}>
            <Grid item md={6} xs={6}>
                <CBAccordionTitle 
                    section={section}
                    label={label}
                />
            </Grid>
                { <Grid item container justifyContent={"flex-end"} md={6} xs={6}>
                    
                    <Grid item>
                        {showCustomIcon && customIcon && onClickCustomIcon &&
                            <Tooltip title={tooltipTitleCustomIcon || ''}>
                                <IconButton
                                    color={"accent"}
                                    disabled={!isExpanded}
                                    onClick={onClickCustomIcon}
                                >
                                    {customIcon}
                                </IconButton>
                            </Tooltip>
                        }
                    </Grid>
                
                    {hasScope(CBAuth.WRITE_CUSTOMER) && <Grid item>
                        {showAdd && 
                            <Tooltip title={tooltipTitleAddIcon || ''} arrow>
                                <span>
                                    <IconButton 
                                        color={"accent"} 
                                        disabled={!editing || !isExpanded || disableAdd}
                                        onClick={onAdd}
                                    >
                                        <AddRounded />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        }
                    </Grid>}
                    {hasScope(CBAuth.WRITE_CUSTOMER) && <Grid item>
                        {showRemove && !!onRemove &&
                            <IconButton 
                                color={"accent"}
                                disabled={!isExpanded}
                                onClick={onRemove}
                            >
                                <DeleteRounded fontSize="small"/>
                            </IconButton>
                        }
                    </Grid>}
                {/*<Grid item>
                        {editing &&
                            <IconButton color="accent"
                                type="submit"
                                disabled={disabledSave}
                                onClick={onSave}
                            >
                                <SaveRounded fontSize="small"/>
                            </IconButton>
                        }
                </Grid>*/}
                {/*<Grid item>
                        {editing ?
                            <IconButton color="accent" 
                                onClick={onResetForm}
                            >
                                <HighlightOffOutlined fontSize="small"/>
                            </IconButton>
                            :
                        <IconButton color="accent"  
                            disabled={!isExpanded || anotherSectionIsInEdit}
                            onClick={(event) => {
                                onSetEditing(event);
                                setAnotherSectionIsInEdit(true);
                            }}
                            >
                                <EditRounded fontSize="small"/>
                            </IconButton>
                        }
                </Grid>*/}
                </Grid>
            }
        </Grid>
    );
}

export default UpdateBtnsAccordion;